import clsx from 'clsx'
import { getCoverImage } from 'helpers/strapi'
import { ArticleType } from 'helpers/strapi/types'
import { ArticlePublishDate, ArticleTags } from 'routes/components/Layout'
import { ArticleCover } from '../ArticleCover'

import classes from './ArticlePreview.module.css'
import { LINKS } from 'routes/constants'

export function ArticlesPreview({
  article,
  variant = 'small',
  showCategory = true,
}: {
  article: ArticleType
  variant?: 'small' | 'medium' | 'large'
  showCategory?: boolean
}) {
  return (
    <div
      className={clsx(
        classes.articlePreview,
        variant === 'small' && classes.articlePreview__small,
        variant === 'medium' && classes.articlePreview__medium,
        variant === 'large' && classes.articlePreview__large,
      )}
    >
      <div className={classes.articlePreview_image}>
        <ArticleCover
          // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
          src={getCoverImage(
            // @ts-expect-error TS(2345): Argument of type 'ImageMediaDataType | undefined' ... Remove this comment to see the full error message
            article.cover,
            variant === 'small' ? 'small' : 'large',
          )}
          alt={article.title}
          className={classes.image}
          fetchPriority={variant === 'large' ? 'high' : undefined}
        />
      </div>
      <div className={classes.articlePreview_description}>
        {/*// @ts-expect-error TS(2322): Type 'CategoryType | undefined' is not assignable ... Remove this comment to see the full error message*/}
        {showCategory && <ArticleTags tags={[article.category]} />}
        <h2 className={classes.header}>
          <a
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            href={`${LINKS.ARTICLES}/${article.category.slug}/${article.slug}`}
          >
            {article.title}
          </a>
        </h2>
        <p className={classes.description}>{article.description}</p>
        <div className={classes.info}>
          {/*// @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message*/}
          <ArticlePublishDate>{article.date}</ArticlePublishDate>
        </div>
      </div>
    </div>
  )
}
